import Long from 'long';
import { AppState } from '../createStore';
import { createSelector } from 'reselect';
import { Reward, RewardType } from '@wix/ambassador-loyalty-rewards/types';
import { LoyaltyAccount } from '@wix/ambassador-loyalty-accounts/types';
import { LoyaltyProgram, ProgramStatus } from '@wix/ambassador-loyalty-programs/types';
import { ChargeV2, hasLoyaltySupport, isLoyaltyDiscount } from '@wix/restaurants-client-logic';
import { EarningRule } from '@wix/ambassador-loyalty-calculator/types';
import _ from 'lodash';

function loyaltyProgramSelectorInner(
  charges: ChargeV2[],
  loyaltyAccount?: LoyaltyAccount,
  loyaltyRewards?: Reward[],
  loyaltyProgram?: LoyaltyProgram,
  loyaltyEarningRules?: EarningRule[],
) {
  const discountAmountReward = loyaltyRewards?.find((r) => r.type === RewardType.DISCOUNT_AMOUNT && r.active);
  const isLoyaltyProgramActive = loyaltyProgram?.status === ProgramStatus.ACTIVE;
  const activityPrerequisite = hasLoyaltySupport(charges) && isLoyaltyProgramActive;
  const loyaltyRewardRevision = discountAmountReward?.revision || Long.ZERO;

  return {
    pointsRequired: discountAmountReward?.requiredPoints || 0,
    currencyValue: Number(discountAmountReward?.discountAmount?.amount || 0),
    pointsBalance: loyaltyAccount?.points?.balance || 0,
    loyaltyRewardId: discountAmountReward?.id, // TODO we need to change this discountAmountReward to appear only if loyalty is there
    customPointsName: loyaltyProgram?.pointDefinition?.customName,
    loyaltyProgramName: loyaltyProgram?.name,
    loyaltyChargesV2: (charges || []).filter(isLoyaltyDiscount),
    isLoyaltyRedeemActive: activityPrerequisite && Boolean(discountAmountReward),
    isLoyaltyEarnActive: activityPrerequisite && !_.isEmpty(loyaltyEarningRules),
    loyaltyEarningRules,
    loyaltyRewardRevision, // TODO we need to change this discountAmountReward to appear only if loyalty is there
  };
}

export const loyaltyProgramSelector = createSelector(
  [
    (state: AppState) => state.session.charges,
    (state: AppState) => state.session.loyaltyAccount,
    (state: AppState) => state.session.loyaltyRewards,
    (state: AppState) => state.session.loyaltyProgram,
    (state: AppState) => state.session.loyaltyEarningRules,
  ],
  loyaltyProgramSelectorInner,
);
